import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Button,
  Grid,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import "./style.css";
// import logo from "../../../imgs/logo-final.png"; // Removed
import CreateAccountForm from "../../molecules/CreateAccountForm";
import downloadAuth from "../../../imgs/download-auth.svg";
import appleStore from "../../../imgs/app-store-badge.png";
import playStore from "../../../imgs/google-store-badge.png";
import { useNavigate, useLocation } from "react-router-dom";
import { confirmInvite, createPassword } from "../../../api/services/services";
import successImg from "../../../imgs/succes.svg";

const CreateAccountPage = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const navigate = useNavigate();
  const [isCreate, setIsCreate] = useState(true);
  const [enable, setEnable] = useState(false);

  const [success, setSucces] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const token = urlData.get("token");
  const type = urlData.get("type");

  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [faToSend, setFatoSend] = useState("");
  const [emailToRegister, setEmailToRegister] = useState("");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleRegister = (formData) => {
    console.log("Create data:", formData);
    const body = {
      type: type,
      password: formData.password,
      passwordConfirmation: formData.confirmPassword,
      name: formData.name,
    };

    createPassword(token, body)
      .then((response) => {
        console.log("Password created");
        setIsValid(true);

        if (type == "admin") {
          setFatoSend(response?.data?.data?.token);
          localStorage.setItem("fa-token", response?.data?.data?.token);
          localStorage.setItem("isAuthPending", true);
          setIsCreate(false);
          setEnable(true);
        } else {
          setIsCreate(false);
          setSucces(true);
        }
      })
      .catch((error) => {
        console.error("Error creating password:", error);
        if (error?.response?.data?.statusCode == 1002) {
          setSnackbarMessage("Token has been expired");

          setOpenSnackbar(true);
        } else {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);
        }
      });
  };

  useEffect(() => {
    let temp = localStorage.getItem("isAuthPending");

    if (temp != null) {
      let val = localStorage.getItem("fa-token");
      setFatoSend(val);
      setIsCreate(false);
      setIsValid(true);
      setIsLoading(false);
      setEnable(true);
    } else {
      confirmInvite(token, type)
        .then((response) => {
          console.log("Email Confirmed");
          setIsValid(true);
          setIsLoading(false);
          setEmailToRegister(response?.data?.data?.email);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching user data:", error.response.data);
          if (error.response.data.statusCode == 1002) {
            setSnackbarMessage("Token has been expired");
            setOpenSnackbar(true);
          } else {
            setSnackbarMessage(error.response.data.message);
            setOpenSnackbar(true);
          }
        });
    }
  }, []);

  return (
    <>
      {isValid ? (
        <div className="login-split-container">
          {/* Left Panel: The Brand Experience */}
          <div className="brand-panel">
            <div className="brand-content">
              <Typography variant="h1" className="brand-title">
                Shelozon Digital
              </Typography>
              <Typography variant="h5" className="brand-tagline">
                Join the future of global logistics.
              </Typography>
            </div>
          </div>

          {/* Right Panel: The Functional Form */}
          <div className="form-panel">
            <Container maxWidth="xs" className="form-container">
                {isCreate && (
                    <>
                      <div className="form-header">
                        <Typography variant="h4" className="form-title">
                           Create Account
                        </Typography>
                        <Typography variant="body1" className="form-desc">
                           Set up your new account to get started
                        </Typography>
                      </div>
                      
                      <CreateAccountForm
                        onSubmit={handleRegister}
                        emailToRegister={emailToRegister}
                      />
                    </>
                )}

                {enable && (
                  <div style={{ textAlign: 'center' }}>
                      <Typography variant="h4" className="form-title mb-1">
                          Setup 2FA
                      </Typography>
                      <Typography variant="body1" className="form-desc mb-4">
                          Authenticator app is required for security
                      </Typography>

                      <img
                        src={downloadAuth}
                        alt="Google Auth"
                        className="mb-3 mt-2 auth-img"
                      />
                      <Typography variant="caption" display="block" className="text-uppercase download mb-2">
                          Available on
                      </Typography>

                      <div className="d-flex justify-content-center mb-4 gap-3">
                        <img
                          src={playStore}
                          alt="PlayStore"
                          className="play-store"
                        />
                        <img
                          src={appleStore}
                          alt="AppleStore"
                          className="play-store"
                        />
                      </div>

                      <Button
                        type="button"
                        variant="contained"
                        className="submit-btn"
                        onClick={() => {
                          navigate("/two-factor-auth", {
                            state: { token: faToSend },
                          });
                        }}
                        fullWidth
                      >
                        Continue to Setup
                      </Button>
                  </div>
                )}

                {success && (
                  <div className="success-container">
                      <img
                        src={successImg}
                        alt="success"
                        width="84"
                        height="84"
                        className="mb-4"
                      />
                      <Typography variant="h5" className="success-title">
                          Account Created!
                      </Typography>
                      <Typography variant="body1" className="form-desc mb-5">
                          Your account has been successfully set up.
                      </Typography>
                    
                      <Button
                        type="submit"
                        variant="contained"
                        className="submit-btn"
                         // Add navigation function here later if needed, mostly for non-admin users
                        disabled
                      >
                        Continue on App
                      </Button>
                  </div>
                )}
            </Container>
          </div>
       </div>
      ) : (
        <>
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </>
      )}

      {/*  */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default CreateAccountPage;
